import { Box, Typography } from "@mui/material";
import { Button, IconShape } from "@caju-beneficios/react-components";
import { EnumGTMEvents } from "services/tagManager/enums/enumGTMEvents";
import { SmsMessageLine, WhatsAppLine } from "@caju-beneficios/react-icons";
import { TagManagerService } from "services/tagManager";

const WHATSAPP_URL_MOBILE =
  "https://wa.me/5511936202859?text=Ol%C3%A1%21+Tenho+interesse+nas+solu%C3%A7%C3%B5es+da+Caju+para+minha+empresa.";

const WHATSAPP_URL_DESKTOP =
  "https://api.whatsapp.com/send/?phone=5511936202859&text=Ol%C3%A1%21+Tenho+interesse+nas+solu%C3%A7%C3%B5es+da+Caju+para+minha+empresa.&type=phone_number&app_absent=0";

const getWhatsappUrl = () =>
  /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)
    ? WHATSAPP_URL_MOBILE
    : WHATSAPP_URL_DESKTOP;

interface WhatsAppContactProps {
  emailDomain?: "corp" | "personal";
  role?: string;
}

export const WhatsAppContact = ({ emailDomain, role }: WhatsAppContactProps) => {
  const handleClick = () => {
    TagManagerService.push(EnumGTMEvents.CONTACT_INFO_WHATSAPP_BTN__CLICK, {
      email_domain: emailDomain,
      role,
      step: "1",
    });
    window.open(getWhatsappUrl(), "_blank", "noopener,noreferrer");
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5, alignItems: "flex-end", maxWidth: 280 }}>
      <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start", width: "100%" }}>
        <IconShape
          variant="accent"
          size="sm"
          icon={<SmsMessageLine />}
          iconLabel="Mensagem"
          style={{ backgroundColor: "var(--ds-color-surface-accent-primary-solid)", color: "var(--ds-color-icons-neutral-inverted)" }}
        />
        <Box>
          <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
            Cadastro pelo WhatsApp
          </Typography>
          <Typography variant="body1" sx={{ color: "#4d4d4d" }}>
            Inicie o processo direto pelo aplicativo de mensagens.
          </Typography>
        </Box>
      </Box>

      <Button
        variant="secondary"
        full
        icon={<WhatsAppLine />}
        iconLabel="WhatsApp"
        onClick={handleClick}
      >
        Abrir WhatsApp
      </Button>
    </Box>
  );
};
